import { Card, CardTitle, CardDescription } from '@/components/ui/card';
import { JurisdictionEnum, LiabilityEnum, type IAgreementUpdateParams } from 'src/graphql/schema';

import AgreementJurisdictionSettings from './AgreementJurisdictionSettings';
import AgreementLiabilitySettings from './AgreementLiabilitySettings';

type Props = {
  jurisdiction?: JurisdictionEnum;
  liability?: LiabilityEnum;
  onJurisdictionUpdate: (agreementParams: IAgreementUpdateParams) => void;
  onLiabilityUpdate: (agreementParams: IAgreementUpdateParams) => void;
};

const AgreementJurisdictionLiabilityCard = ({
  jurisdiction,
  liability,
  onJurisdictionUpdate,
  onLiabilityUpdate,
}: Props) => {
  return (
    <Card className="grid grid-cols-1 md:grid-cols-2 gap-4 p-5">
      <div className="space-y-2">
        <CardTitle className="text-sm font-semibold">Jurisdiction</CardTitle>
        <CardDescription>
          Choose which country&apos;s or region&apos;s laws govern this agreement if a dispute arises.
        </CardDescription>
        <AgreementJurisdictionSettings onUpdate={onJurisdictionUpdate} jurisdiction={jurisdiction} />
        <CardDescription>By default, the agreement follows the escrow agent&apos;s jurisdiction.</CardDescription>
      </div>
      <div className="space-y-2">
        <CardTitle className="text-sm font-semibold">Liability limit</CardTitle>
        <CardDescription>Choose the maximum liability the escrow agent carries under this agreement.</CardDescription>
        <AgreementLiabilitySettings onUpdate={onLiabilityUpdate} liability={liability} />
        <CardDescription>
          The standard limit caps liability at 12 months&apos; fees, in line with other source code management
          platforms. Non-standard limits require the Liability SLA Add-On.
        </CardDescription>
      </div>
    </Card>
  );
};

export default AgreementJurisdictionLiabilityCard;
